export const environment = {
    production: true,
    apiUrl: 'https://api.tallamapp.com/',
    taxVat:15
};
